export default function setTransition(duration, byController) {
  const swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/core/transition/setTransition.js
// module id = 1177
// module chunks = 9